import ReactDOM from "react-dom/client";

import "./index.css";

import App from "./App";

import {
  HelmetProvider
} from "react-helmet-async";

import reportWebVitals
  from "./reportWebVitals";

/* ===============================
   ROOT
=============================== */

const root =
  ReactDOM.createRoot(
    document.getElementById("root")
  );

/* ===============================
   RENDER
=============================== */

root.render(

  <HelmetProvider>

    <App />

  </HelmetProvider>

);

/* ===============================
   WEB VITALS
=============================== */

reportWebVitals();